<!-- partProgress / 步驟條
  參數: 
  1、totalStep  總共步驟數
  2、step       當前的步驟
-->
<template>
  <div class="part-progress">
    <template v-for="(n, index) in totalStep" >
      <!-- <img :key="'complete' + index" v-if="n < step" class="progress-complete" src="@A/images/complete.png" :alt="n"  alt="Step n, Completed" @click="toPage(n,step)">
      <span :key="'progress' + index" v-else class="progress-circle" :class="n == step?'active':''" alt="Test"><span @click="toPage(n,step)" style=" text-decoration: none;">{{n}}</span></span>
      <span :key="'line'+index" v-if="n < totalStep" class="progress-line" :class="n < step?'complete':''" :style="ieFlag?'margin: 0 0 0.1rem 0;': 'margin: 0.25rem 0'"></span> -->
    </template>
  </div>
</template>
<script>
export default {
  props: {
    totalStep: {
      type: Number,
      default: 4
    },
    step: {
      type: Number,
      default: 1
    }
  },
  data(){
    return{
      ieFlag:''
    }
  },
  methods: {
    toPage(page,step){
      console.log(`To ${page} Current Page: ${step}`)
      let url = "";
      switch(page){
        case 1:case 2:case 3:case 4: url = '/part'+page;break;
        default: url = '/home';
      }
      console.log(this.complaintData)
      if(page<step){
        console.log(`Navigating to Pervious Stap, Request OK`)
      }else{
        console.log(`Navigating to Next Stap, Request Blocked`)
      }
      this.sessionSetItem('urlFlag','#'+url)
      this.$toPage(url)
    }
    
    
  },
  mounted(){
    this.ieFlag = false
    var Sys = {};
    var ua = navigator.userAgent.toLowerCase();
    var s;
    (s = ua.match(/msie ([\d.]+)/)) ? Sys.ie = s[1] : 0
    // this.ieNum = Sys.ie
    if(Sys.ie == 9.0){
      this.ieFlag = true
    }
    console.log(`If Browser = IE: ${this.ieFlag}`);
  }
}
</script>

<style lang="scss" scoped>
// 樣式是progress.scss, 在all.scss中引入
</style>



// WEBPACK FOOTER //
// src/components/partProgress.vue